<template>
<div class="apCodeUpload-page-content ">
    <div class="main-block position-relative winner-page__hero">
        <div class="position-relative">
            <div class="container-xl">
                <div class="row">

                    <div class="col-12 col-lg-6 d-flex justify-content-center flex-column align-items-lg-start align-items-center">
                        <h1 class="mb-3 text-white" style="text-transform: none;">
                            <!-- <img class="img-fluid" style="border-radius:8px;" :src="`${baseUrl}/lang_images/winner_${$store.state.currentLang}.png`" alt="winner" width="320"/> -->
                            {{tr('winner-congrat')}}
                        </h1>
                        <p class="main-block__hero--p text-center text-lg-left" v-if="winnerType != 'main'">Érvényes pályázat esetén nyereményed</p>
                        <p class="main-block__hero--p text-center text-lg-left" v-if="winnerType == 'main'">Érvényes pályázat esetén megnyerted</p>
                        <p class="main-block__hero--p  text-center text-lg-left" v-if="winnerType == 'main'">fődíjunkat!</p>
                        <p class="main-block__hero--p  text-center text-lg-left" v-if="winnerType == 'utalvany_80'">1db 80.000 Ft értékű Lidl ajándékutalvány.</p>
                        <p class="main-block__hero--p  text-center text-lg-left" v-if="winnerType == 'utalvany_40'">1db 40.000 Ft értékű Lidl ajándékutalvány.</p>
                        <p class="main-block__hero--p  text-center text-lg-left" v-if="winnerType == 'utalvany_20'">1db 20.000 Ft értékű Lidl ajándékutalvány.</p>   

                        <!-- FOR Mobile  -->
                        <img v-if="winnerType == 'utalvany_20'" :src="`${baseUrl}/lang_images/winnings/utalvany_20.png`" :alt="tr('winnings-img-alt-napi')" class="img-fluid d-lg-none d-block" />
                        <img v-if="winnerType == 'utalvany_40'" :src="`${baseUrl}/lang_images/winnings/utalvany_40.png`" :alt="tr('winnings-img-alt-heti')" class="img-fluid  d-lg-none d-block" />
                        <img v-if="winnerType == 'utalvany_80'" :src="`${baseUrl}/lang_images/winnings/utalvany_80.png`" :alt="tr('winnings-img-alt-heti')" class="img-fluid  d-lg-none d-block" />
                        <img v-if="winnerType == 'main'" :src="`${baseUrl}/lang_images/winnings/fodij.png`" alt="whiskas" class="img-fluid  d-lg-none d-block"/>  
                       
                      <!--  <p class="main-block__hero--p  text-center text-lg-left" v-if="winnerType == 'weekly'">{{ tr('winner-hero-sub-h1-weekly') }}</p>
                        <p class="main-block__hero--p  text-center text-lg-left" v-if="winnerType == 'daily'">{{ tr('winner-hero-sub-h1-daily') }}</p>-->
                        
                        <button v-if="needBtn" class="btn btn-primary mt-4 mb-5" v-scroll-to="{ el: '#winnerForm', offset: -80 }">{{tr('kerem-a-nyeremenyem')}}</button>

                     <!--   <p class="real-info-txt pb-5 text-center mx-auto text-white d-lg-none d-block">{{tr('winner-hero-info')}}</p>-->
                    </div> 
                    <!-- IMG - desctop     -->
                    <div class="col-12 col-lg-5 offset-lg-1 align-self-center py-5 d-none d-lg-block">
                        <div class="winnerType-bgr">
                            <img v-if="winnerType == 'utalvany_20'" :src="`${baseUrl}/lang_images/winnings/utalvany_20.png`" :alt="tr('winnings-img-alt-napi')" class="img-fluid" />
                            <img v-if="winnerType == 'utalvany_40'" :src="`${baseUrl}/lang_images/winnings/utalvany_40.png`" :alt="tr('winnings-img-alt-heti')" class="img-fluid" style="z-index:2;" />
                            <img v-if="winnerType == 'utalvany_80'" :src="`${baseUrl}/lang_images/winnings/utalvany_80.png`" :alt="tr('winnings-img-alt-heti')" class="img-fluid" style="z-index:2;" />
                            <img v-if="winnerType == 'main'" :src="`${baseUrl}/lang_images/winnings/fodij.png`" alt="whiskas" class="img-fluid"/>           
                        </div>
                    </div>  
                
                </div>
            </div>
          <!--   <div class="p-3 d-none d-lg-block" style="background: #ff000000;">
                <p class="real-info-txt py-4 text-center mx-auto text-white">{{tr('winner-hero-info')}}</p>
            </div>  -->
        </div>
   </div>
   <!--<div class="text-center mx-auto bg-secondary">
        <button v-if="needBtn" class="btn btn-secondary mt-4 mb-4 d-none mx-auto" v-scroll-to="{ el: '#winnerForm', offset: -80 }">{{tr('kerem-a-nyeremenyem')}}</button>
        <p class="real-info-txt py-4 text-center mx-auto text-primary">{{tr('winner-hero-info')}}</p>
    </div>-->
</div>
</template>

<script>
export default {
    props:['winnerType', 'needBtn']
}
</script>